export default __webpack_public_path__ + "static/media/sortOnlyDown.89938e52.svg";